export default __webpack_public_path__ + "static/media/stadium.ba400d5a.png";